<template>
  <div>
    <el-row>
      <el-button type="success" size="small" @click="addDialogVisible = true">添加用户</el-button>
    </el-row>
    <el-table :data="accountTableData" v-loading="loading">
      <el-table-column label="用户名" prop="username" align="center"></el-table-column>
      <el-table-column label="名称" prop="account_name" align="center"></el-table-column>
      <el-table-column label="被禁止的权限" align="center">
        <template slot-scope="scope">
          <span v-for="access in scope.row.access.split(',')" :key="access">{{accessMap[access]}}&nbsp;</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="showEdit(scope.row)">编辑</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定重置密码为123456吗？"
            @onConfirm="resetPassword(scope.row)"
          >
            <el-link slot="reference" type="primary">重置密码</el-link>
          </el-popconfirm>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @onConfirm="deleteAccount(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加用户" width="500px" :visible.sync="addDialogVisible">
      <el-form :model="addForm" ref="addForm" :rules="rules" label-width="150px">
        <el-form-item label="用户名" prop="username">
          <el-input style="width:200px" size="small" v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            style="width:200px"
            size="small"
            v-model="addForm.password"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="account_name">
          <el-input style="width:200px" size="small" v-model="addForm.account_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="addAccount">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" width="700px" :visible.sync="editDialogVisible">
      <el-form :model="editForm" ref="editForm" :rules="rules" label-width="150px">
        <el-form-item label="用户名">{{editForm.username}}</el-form-item>
        <el-form-item label="名称" prop="account_name">
          <el-input style="width:200px" size="small" v-model="editForm.account_name"></el-input>
        </el-form-item>
        <el-form-item label="禁止权限" prop="accessList">
          <el-checkbox-group v-model="editForm.accessList">
            <el-checkbox v-for="(access,key) in accessMap" :key="key" :label="key">{{access}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="editDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="editAccount">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAccountList, addAccount, deleteAccount, editAccount, resetPassword } from '../api/index'
import { getEncryptionPassword } from '../assets/lib/utils'
export default {
  data () {
    return {
      loading: false,
      addDialogVisible: false,
      editDialogVisible: false,
      accountTableData: [],
      accessMap: {
        '1': '账号管理',
        '2': '财务相关',
        '3': '订单相关',
        '4': '生产相关',
        '5': '采购相关',
        '6': '产品列表增删改',
        '7': '原料列表增删改',
        '8': '配置'
      },
      addForm: {
        account_name: '',
        username: '',
        password: ''
      },
      editForm: {
        id: '',
        account_name: '',
        accessList: []
      },
      rules: {
        account_name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请填写用户名', trigger: 'blur' },
          { pattern: /^([a-z]|[A-Z]|[0-9]){3,18}$/, message: '用户名应由3~18个字符或数字组成', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' },
          { pattern: /^.{6,18}$/, message: '密码应在6~18个字符之间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    addAccount () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          const params = {
            account_name: this.addForm.account_name,
            username: this.addForm.username,
            password: getEncryptionPassword(this.addForm.username, this.addForm.password)
          }
          addAccount(params).then(res => {
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.addDialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    resetPassword (row) {
      let params = {
        id: row.id,
        password: getEncryptionPassword(row.username, '123456')
      }
      resetPassword(params).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editAccount () {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          const params = {
            id: this.editForm.id,
            account_name: this.editForm.account_name,
            username: this.editForm.username,
            access: this.editForm.accessList.join(',')
          }
          editAccount(params).then(res => {
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.editDialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    showEdit (row) {
      this.editDialogVisible = true
      let accessList = row.access.split(',')
      if (accessList.length === 1 && accessList[0] === '') {
        accessList = []
      }
      this.editForm = {
        id: row.id,
        username: row.username,
        account_name: row.account_name,
        accessList: accessList
      }
    },
    deleteAccount (id) {
      deleteAccount({ id }).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getList () {
      this.loading = true
      getAccountList().then(res => {
        if (res.data.status === 200) {
          this.accountTableData = res.data.data
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
